define('views/pages/SensoryTripPageView',['underscore','jquery','PageView','app'],function(_,$,PageView,app){


    return PageView.extend({
        pageName:'SensoryTrip',
        events:{

        },

        initialize:function(options){


            // PageView constructor heritage
            PageView.prototype.initialize.apply(this,arguments);
            //

            var view = this.$el,
                video = view.find('video'),
                progressInterval;

            video.bind('canplay', function(){
                video[0].play();
            });

            $('.video').click(toggleVideo);

            $(window).scroll(function(){
                var scrollT = $(window).scrollTop();
                if(scrollT > video.offset().top + video.height() / 2){
                    video[0].pause();
                    $('.play-icon').addClass('active');
                }else{
                    video[0].play();
                    $('.play-icon').removeClass('active');
                }
            });

            function toggleVideo(){
                if(video[0].paused){
                    video[0].play();
                    $('.play-icon').removeClass('active');
                }else{
                    video[0].pause();
                    $('.play-icon').addClass('active');
                }
            }

            function updateProgressBar(){
                var percentage = (100 / video[0].duration) * video[0].currentTime;
                view.find('.progress-bar').css('left', percentage + '%');
            }

            video.bind('play', function(){
                progressInterval = setInterval(function(){
                    updateProgressBar();
                }, 1000/24);
            });

            video.bind('pause', function(){
                clearInterval(progressInterval);
            });


            // Canvas

            var v = document.getElementById('video');
            var canvas = document.getElementById('canvas');
            var context = canvas.getContext('2d');

            var cw = Math.floor(canvas.clientWidth / 2);
            var ch = Math.floor(canvas.clientHeight / 2);
            canvas.width = cw;
            canvas.height = ch;

            v.addEventListener('play', function(){
                draw(this,context,cw,ch);
            },false);

            function draw(v,c,w,h) {
                if(v.paused || v.ended) return false;
                c.drawImage(v,0,0,w,h);
                c.filter = "blur(50px)";
                setTimeout(draw,20,v,c,w,h);
            }

        }

    })

})
;
